import React from 'react'
import {Grid, Tooltip} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

/*
 * Shared by both dashboards so the wording can't drift between them. It spells
 * out that refunds are already deducted because hotels were subtracting them a
 * second time in their own PMS, and that the days of a payout period add up to
 * the payout, which is how hotels reconcile this figure.
 */
export const REVENUE_INFO =
    "Your share of revenue for the selected date: bookings that closed on that date, " +
    "plus gate charges taken on it, after Drivo's commission and fees. Refunds " +
    "on those bookings have already been deducted here, so don't deduct them again in " +
    "your PMS. The Bookings Closed tab in the download lists the bookings behind " +
    "this figure."

const useStyles = makeStyles(() => ({
    cardText: {
        fontSize: '18px',
        fontWeight: 500,
        opacity: 0.72,
    },
    infoIcon: {
        display: 'inline-flex',
        verticalAlign: 'middle',
        marginLeft: '6px',
        cursor: 'help',
    },
    infoTooltip: {
        fontSize: '13px',
        lineHeight: 1.5,
    }
}))

/*
 * `info` is optional — rows that don't pass it render exactly as they always
 * have. It is wrapped in a span rather than put on the icon directly so the
 * tooltip has something focusable to anchor to for keyboard and touch users.
 */
function DailyReportTable({leftSide, rightSide, info}) {
    const classes = useStyles()
    return (
        <>
            <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.cardText}>
                    {leftSide}
                    {info && (
                        <Tooltip
                            title={info}
                            arrow
                            enterTouchDelay={0}
                            leaveTouchDelay={10000}
                            classes={{tooltip: classes.infoTooltip}}
                        >
                            <span
                                className={classes.infoIcon}
                                tabIndex={0}
                                role="img"
                                aria-label={`How ${leftSide} is calculated`}
                            >
                                <InfoOutlinedIcon fontSize="inherit"/>
                            </span>
                        </Tooltip>
                    )}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.cardText}>
                    {rightSide}
                </Typography>
            </Grid>
        </>
    )
}

export default DailyReportTable
